module.exports = __webpack_public_path__ + "img/qrcode.db34515d.png";